import React, { useState } from "react";
import Contacts from "@/pages/contacts";
import Denmarkstudentvisaimport from "@/pages/denmarkstudentvisaimport";
const Denmarkvisitvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/denmarked.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
         
        </div>
      </div>
      <div className="px-5 md:ml-64 md:mt-10 md:w-3/4">
  <h1 className="text-center mt-10 text-2xl font-bold text-[#011473] drop-shadow-md md:text-left md:text-3xl">
    Explore Denmark: Begin Your Journey with Visa World
  </h1>
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/den.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-8 lg:w-1/2">
  <div>
    <h2 className="font-bold text-xl text-[#011473]">Why Choose Visa World for Your Denmark Visit Visa?</h2>
    <p className="mt-2 text-gray-700">
      Visa World offers exceptional services for Denmark visit visas, providing tailored assistance and expert advice.
      Our skilled consultants streamline the application process, ensuring a hassle-free experience to help you fulfill
      your travel aspirations.
    </p>
  </div>

  <div>
    <h3 className="font-semibold text-lg text-[#011473]">Types of Denmark Visit Visas:</h3>
    <ul className="mt-2 space-y-4">
      <li className="flex items-start">
        <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <span className="ml-3 text-gray-700">
          <strong className="text-black">Tourist Visa:</strong> Perfect for leisure trips, sightseeing and discovering Denmark's cultural treasures.
        </span>
      </li>

      <li className="flex items-start">
        <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <span className="ml-3 text-gray-700">
          <strong className="text-black">Family Visit Visa:</strong> Designed for visiting family or friends living in Denmark.
        </span>
      </li>

      <li className="flex items-start">
        <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <span className="ml-3 text-gray-700">
          <strong className="text-black">Business Visa:</strong> Ideal for attending meetings, conferences, or other business engagements in Denmark.
        </span>
      </li>

      <li className="flex items-start">
        <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <span className="ml-3 text-gray-700">
          <strong className="text-black">Short-Term Study Visa:</strong> Suitable for attending short courses or research programs lasting up to 90 days.
        </span>
      </li>
    </ul>
  </div>
</div>


      </div>
      
      <div className="px-4 md:px-10 lg:px-20">
  <p className="mb-5 text-xl font-bold text-[#011473] md:text-2xl">
    Essential Documents Required for a Denmark Visit Visa
  </p>
  <div className="space-y-4 mb-20">
    {[
      "A valid passport with sufficient validity.",
      "Duly filled visa application form.",
      "Recent passport-sized photographs meeting the visa specifications.",
      "Evidence of financial capability to support your stay.",
      "Detailed travel plan, including flight and accommodation information.",
      "Valid travel insurance covering the duration of your visit.",
      "Invitation letter from a host (if applicable).",
      "Proof of current employment or enrollment in an educational institution (if required).",
      "Receipt confirming payment of the visa application fee.",
    ].map((item, index) => (
      <div
        key={index}
        className="flex items-center text-left md:text-center md:justify-start"
      >
        <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <span className="ml-3 font-medium text-gray-700">{item}</span>
      </div>
    ))}
  </div>
</div>



      <Denmarkstudentvisaimport />
      <div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center rounded-md text-black bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        - <strong>Why Choose Denmark for Your Next Adventure?</strong>  
        <br />
        - <strong>Exquisite Travel Destination:</strong> Denmark offers a blend of stunning landscapes, historical sites and vibrant cities.  
        <br />
        - <strong>Cultural Richness:</strong> Experience Denmark's unique blend of modern innovation and deep-rooted traditions.  
        <br />
        - <strong>Seamless Connectivity:</strong> As part of the Schengen Zone, Denmark allows easy travel to neighboring European countries.  
        <br />
        - <strong>Safe and Friendly Environment:</strong> Denmark ranks among the safest and most welcoming countries for travelers.  
        <br />
        - <strong>Culinary Delights:</strong> Indulge in world-renowned Danish cuisine, from traditional smørrebrød to Michelin-starred restaurants.  
        <br />
        - <strong>Effortless Visa Processing:</strong> Obtain your Denmark Visit Visa with Visa World's expert assistance and enjoy a smooth application process.  
        <br />
        Embark on an unforgettable journey to Denmark—apply for your visit visa today!  
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Why Visit Denmark? Learn More
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>



     
      <Contacts />
    </>
  );
};

export default Denmarkvisitvisa;
